import { flare } from "@flareapp/js";

// Normalize unknown errors to Error instances
export function toError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }

    if (typeof error === 'string') {
        return new Error(error);
    }

    try {
        return new Error(JSON.stringify(error));
    } catch {
        return new Error(String(error));
    }
}

// Shared error reporting function
export function reportErrorToFlare(error: Error, source: string) {
    if (import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'production') {
        flare.report(error).catch((flareError) => {
            console.error(`Failed to report ${source} error to Flare:`, flareError);
        });
    } else {
        // Log errors in development
        console.error(`Error caught by ${source}:`, error);
    }
}